import type { ComponentProps } from 'react';
import { OwcDivider } from '@one/react';

export type PocDividerProps = ComponentProps<typeof OwcDivider>;

export const PocDivider: React.FC<PocDividerProps> = (props) => <OwcDivider {...props} />;
